<!--
  PlanOverrideModal.vue
  콜봇 월 정산 · 회사 예외 모달(`[예외 추가/수정]`) — 화면 명세 2-1 "예외 모달 필드", 요청 계약 3-2·3-3.

  요청: ~/md/front/admin-콜봇-월정산-프론트요청.md
  칸: ~/md/front/admin-콜봇-월정산-call-api-구현회신.md "2026-10-16 개정 — 요금표 v70" 2(덮을 수 있는 칸)
  - 적용 시작 월(기본: 상세의 달). 그 달 예외 버전이 있으면 그 버전을 고치고, 없으면 직전 예외 버전 값을
    복사해 새 버전으로 연다. 예외 버전끼리는 쌓이지 않는다 — 그 달에는 가장 최근 버전 하나만 쓴다.
  - 칸 목록은 기본 요율과 같다(RATE_CELLS 중 overridable — 구분 · 월 사용료(VAT 포함)·포함 통화 · 120분 초과 통화·
    발신 건당·받은 발신 통화 · 웹 텍스트 · 추가 070 회선·대표번호 회선 · 상담사 번호 기본 포함 수·추가 1개당 월 금액).
    칸마다 "기본 따름"(기본 선택)과 값 중 하나 —
    "기본 따름" 옆 회색 값은 적용 시작 월에 적용되는 기본 요율 버전의 값이다. 값을 넣은 칸만 예외가 된다.
    예외로 "미정"은 만들 수 없다(무료는 0). 원가·단위를 모르는 칸은 입력을 막는다("원가 확인 뒤 입력").
    구분·웹 텍스트는 고르는 칸, 나머지는 RatePriceField(mode 'override')다.
    원가는 오늘 cost_rates(settlementRules.cellCostInfo 'live'), 단위(입력 앞·"기본 따름" 값·저장 확인창)는 그 달
    기본 버전 것이 먼저다 — 예외 판매가는 기본 버전의 단위로 계산된다(유효 요율 카드와 같다).
  - 배치(2026-10-27 목업에 맞춤): 기본 요율 편집 모달과 같은 이름 | 입력 | 원가(참고) 세 칸, 묶음과 칸 이름은 요율 표와 같다
    (기본 · 통화 · 10초 단위 · 회선 · 웹 텍스트 · 상담사 번호). 맨 위 설명은 한 문장, 나머지 규칙은 그 문장의 툴팁.
  - 상담사 번호 묶음(~/md/front/admin-콜봇-상담사번호-추가요금-프론트요청.md A2): 묶음 힌트(한 달만 빼려면 정산서 항목
    금액), 직전 예외 버전에서 복사돼 온 값 표시(한 달 면제 뒤 0 을 되돌리는 것을 잊지 않게), 그 달
    기본 요율에 블록이 없으면 "기본 따름" 값이 '요금 없음'이고 예외 값이 그 달에는 쓰이지 않는다는 안내. 0 이상 정수만 받는다.
  - 상담사 연결(통화 넘기기)은 월 사용료에 들어 있어 예외 칸이 없다(판매가 없음). 부가세(별도 고정)·상담사 연결·부가 항목은
    읽기 전용으로 보인다.
  - 고치거나 복사할 예외 버전에 요금표 v70 이전 칸(`ai.price_per_unit`·`counselor.*.price`)이 남아 있으면 계산에 쓰지
    않고 저장하면 빠진다고 알린다(legacyOverrideCells). 보내지 않는다 — 보내면 400 이다.
  - 그 달 기본 버전이 v70 이전 모양이면 "기본 따름" 값을 보일 수 없다(그 달은 기본 요율 없음 — 계산하지 않는다).
  - 검증(message.warning): 0 이상의 숫자, 소수 둘째 자리까지, 월 사용료·포함 통화는 정수(validateRateCell),
    예외 사유 메모 필수.
  - `[저장]` → 확인창(세 가지 영향) → PUT .../plan-overrides/:effectiveFrom(덮을 칸만 + memo — 그 버전을
    통째로 바꾼다). `[예외 전부 해제]` → 확인창 → 같은 경로에 { memo } 만(칸 없는 버전 — 이 달부터 기본만).
  - 성공하면 saved 만 보낸다(닫기·다시 부르기·안내는 요율 탭 몫). 실패하면 창을 연 채 알린다.

  - props: open · companyId · companyName · month(상세의 달) · overrides · defaultPlans · costRates · api
  - emits: close · saved({ kind: 'saved' | 'cleared', effectiveFrom })
-->
<template>
  <a-modal :open="open" :footer="null" :mask-closable="false" width="760px" @cancel="handleCancel">
    <template #title>
      <div class="modal-title">
        예외 추가/수정<span v-if="companyName" class="modal-title__sub">{{ companyName }}</span>
      </div>
    </template>

    <div class="modal-content">
      <div class="override-form">
        <p class="override-form__intro">
          값을 넣은 칸만 예외가 되고, 나머지는 그 달 기본 요율을 따릅니다.
          <a-tooltip :title="INTRO_TOOLTIP">
            <QuestionCircleOutlined class="override-form__help" aria-label="예외 규칙 더 보기" />
          </a-tooltip>
        </p>

        <div class="override-form__month">
          <label class="override-form__label" :for="monthId">적용 시작 월</label>
          <div class="override-form__month-body">
            <a-date-picker
              :id="monthId"
              class="override-form__picker"
              :value="form.effectiveFrom"
              picker="month"
              value-format="YYYY-MM"
              format="YYYY-MM"
              :locale="locale"
              :allow-clear="false"
              :input-read-only="true"
              :disabled="saving"
              @change="onMonthChange"
            />
            <span class="override-form__version">{{ versionNote }}</span>
          </div>
        </div>
        <p class="override-form__hint">{{ defaultPlanNote }}</p>
        <a-alert v-if="usedByConfirmedText" type="info" show-icon :message="usedByConfirmedText" />
        <a-alert v-if="legacyCellsText" type="warning" show-icon :message="legacyCellsText" />

        <div class="override-form__colhead" aria-hidden="true"><span>원가 (참고)</span></div>

        <section
          v-for="group in GROUPS"
          :key="group.key"
          class="override-form__group"
          :aria-labelledby="`${uid}-group-${group.key}`"
        >
          <h3 :id="`${uid}-group-${group.key}`" class="override-form__group-title">
            {{ group.label }}<small v-if="group.sub"> · {{ group.sub }}</small>
          </h3>
          <p v-if="group.hint" class="override-form__group-hint">{{ group.hint }}</p>
          <p
            v-if="group.key === 'counselor_number' && counselorNoBlockNote"
            class="override-form__group-hint is-warn"
            :title="COUNSELOR_NO_BLOCK_TITLE"
          >
            {{ counselorNoBlockNote }}
          </p>

          <template v-for="cell in group.cells" :key="cell.key">
            <!-- 구분·웹 텍스트 — 값이 참/거짓이라 고르는 칸 -->
            <div
              v-if="isChoiceCell(cell)"
              class="choice-field"
              role="group"
              :aria-labelledby="`${uid}-choice-${cell.key}`"
            >
              <span :id="`${uid}-choice-${cell.key}`" class="choice-field__label">{{ fieldLabel(cell) }}</span>
              <div class="choice-field__body">
                <a-radio-group v-model:value="choices[cell.key]" class="choice-field__options" :disabled="saving">
                  <a-radio :value="FOLLOW">
                    기본 따름
                    <span class="choice-field__default">{{ info[cell.key].defaultText }}</span>
                  </a-radio>
                  <a-radio v-for="opt in CHOICE_OPTIONS[cell.key]" :key="String(opt.value)" :value="opt.value">
                    {{ opt.label }}
                  </a-radio>
                </a-radio-group>
              </div>
              <span class="choice-field__cost">{{ info[cell.key].costText || EMPTY }}</span>
              <p v-if="choiceHint(cell.key)" class="choice-field__hint">{{ choiceHint(cell.key) }}</p>
            </div>

            <RatePriceField
              v-else
              v-model:value="values[cell.key]"
              v-model:follow="follow[cell.key]"
              mode="override"
              :label="fieldLabel(cell)"
              :unit-text="info[cell.key].unitText"
              :suffix="suffixOf(cell)"
              :step="cell.kind === 'fee' ? 1000 : 1"
              :cost="info[cell.key].cost"
              :cost-text="info[cell.key].costText"
              :locked="info[cell.key].locked"
              :default-text="info[cell.key].defaultText"
              :hint="fieldHint(cell)"
            />
          </template>
        </section>

        <section class="override-form__group is-readonly" :aria-labelledby="`${uid}-group-readonly`">
          <h3 :id="`${uid}-group-readonly`" class="override-form__group-title">예외로 덮지 않는 칸</h3>
          <dl class="readonly-list">
            <div class="readonly-list__row">
              <dt>부가세</dt>
              <dd>{{ VAT_LABEL }} · 전역 고정</dd>
            </div>
            <div class="readonly-list__row">
              <dt>상담사 연결</dt>
              <dd>월 사용료에 포함 · 판매가 없음</dd>
            </div>
            <div class="readonly-list__row">
              <dt>부가 항목</dt>
              <dd>{{ extrasText }}</dd>
            </div>
          </dl>
        </section>

        <div class="override-form__memo">
          <label class="override-form__label" :for="memoId">예외 사유 메모 <em>*</em></label>
          <a-textarea
            :id="memoId"
            v-model:value="form.memo"
            :rows="2"
            :maxlength="MEMO_MAX"
            show-count
            :disabled="saving"
            placeholder="예: 계약에 따라 월 사용료를 88,000원(VAT 포함)으로 받음"
          />
          <p v-if="memoHint" class="override-form__hint">{{ memoHint }}</p>
        </div>
      </div>

      <div class="modal-footer">
        <!-- 비활성 버튼은 툴팁이 span 으로 감싸므로 왼쪽 정렬은 바깥 span 이 맡는다 -->
        <span class="modal-footer__start">
          <a-tooltip :title="clearBlockedReason || undefined">
            <a-button danger :disabled="!!clearBlockedReason || saving" @click="confirmClear">예외 전부 해제</a-button>
          </a-tooltip>
        </span>
        <a-button :disabled="saving" @click="handleCancel">취소</a-button>
        <a-button type="primary" class="yellow-button" :loading="saving" @click="confirmSave">저장</a-button>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import { computed, getCurrentInstance, h, reactive, ref, watch } from 'vue';
import { Modal, message } from 'ant-design-vue';
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import 'dayjs/locale/ko';

import { QuestionCircleOutlined } from '@ant-design/icons-vue';

import RatePriceField from '../RatePriceField.vue';
import {
  EMPTY,
  addMonths,
  currentMonthKst,
  formatNumber,
  isNumber,
  isValidMonth,
} from '../../service/settlementFormat';
import {
  OVERRIDE_SAVE_EFFECT_LINES,
  RATE_CELLS,
  RATE_CELL_MAP,
  RATE_GROUP_LABELS,
  STATEMENT_LINE_LABELS,
  VAT_LABEL,
  categoryLabel,
  cellCostInfo,
  counselorNumberRates,
  effectiveDefaultPlan,
  effectiveOverride,
  extraItemRows,
  formValuesToOverrideBody,
  formatCostValue,
  formatRateValue,
  getPath,
  isCostUnknown,
  isLegacyPlan,
  legacyOverrideCells,
  overrideBodyCellKeys,
  overrideToFormValues,
  readCell,
  unitLabel,
  validateRateCell,
} from '../../service/settlementRules';
import { getCallApiErrorStatus, parseCallApiError } from '@/views/Callbot/service/callApiError';

const MEMO_MAX = 500;
/** 고르는 칸의 "기본 따름" 값 */
const FOLLOW = 'follow';

const CLEAR_LEAD = '이 적용 시작 월부터 예외 없이 기본만 씁니다. 이전 달 예외 버전은 남습니다.';
const MEMO_REQUIRED_TEXT = '예외 사유 메모를 입력하세요.';
const NO_CELLS_TEXT = '덮은 칸이 없습니다. 이 적용 시작 월부터 예외 없이 기본만 쓰려면 [예외 전부 해제]를 누르세요.';
/** 덮은 칸이 없는데 [예외 전부 해제]도 꺼진 때(그 달에 쓰는 예외 칸이 원래 없다) — 누를 수 없는 버튼으로 보내지 않는다 */
const NO_CELLS_NOTHING_TO_CLEAR_TEXT =
  '덮은 칸이 없습니다. 예외로 둘 칸에 값을 넣으세요 — 이 적용 시작 월에는 지금도 기본 요율만 씁니다.';
const UNAVAILABLE_TEXT = '회사 예외 API 가 아직 call-api 에 배포되지 않았습니다.';
/** 맨 위 한 문장의 나머지 규칙 */
const INTRO_TOOLTIP =
  '칸마다 "기본 따름"과 값 입력 중 하나를 고릅니다. 예외로 "미정"은 만들 수 없습니다 — 무료로 하려면 0 을 넣으세요. 상담사 연결(통화 넘기기)은 월 사용료에 들어 있어 예외 칸이 없습니다.';
/** 그 달 기본 요율에 상담사 번호 요금이 없을 때 안내의 나머지 */
const COUNSELOR_NO_BLOCK_TITLE = '뒤의 기본 요율 버전에 요금이 생기면 그 달부터 다음 예외 버전 전까지 이 예외 값을 씁니다.';

/** 예외로 덮을 수 있는 칸(요청 계약 3-2) — 표시 순서 */
const OVERRIDE_CELLS = RATE_CELLS.filter((c) => c.overridable);
const CHOICE_KINDS = new Set(['internal', 'pass_through']);
const CHOICE_CELLS = OVERRIDE_CELLS.filter((c) => CHOICE_KINDS.has(c.kind));
const PRICE_CELLS = OVERRIDE_CELLS.filter((c) => !CHOICE_KINDS.has(c.kind));

/**
 * 묶음 — 요율 표와 같은 순서·이름: 기본(구분 · 월 사용료 · 포함 통화) · 통화 · 10초 단위 · 회선 · 웹 텍스트(회선 먼저) ·
 * 상담사 번호(묶음 힌트 — 번호 요청 A2)
 */
const GROUPS = [
  { key: 'base', label: RATE_GROUP_LABELS.base, groups: ['basic', 'base'] },
  { key: 'call', label: RATE_GROUP_LABELS.call, sub: '10초 단위', groups: ['call'] },
  { key: 'line-web', label: `${RATE_GROUP_LABELS.line} · ${RATE_GROUP_LABELS.web}`, groups: ['line', 'web'] },
  {
    key: 'counselor_number',
    label: RATE_GROUP_LABELS.counselor_number,
    groups: ['counselor_number'],
    hint: `한 달만 빼려면 예외 대신 그 달 정산서의 '${STATEMENT_LINE_LABELS.counselor_number}' 항목 금액을 고치세요.`,
  },
]
  .map(({ key, label, sub = '', groups, hint = '' }) => ({
    key,
    label,
    sub,
    hint,
    // 묶음 안 순서는 groups 순서(회선 → 웹 텍스트), 같은 묶음 안은 RATE_CELLS 순서
    cells: groups.flatMap((g) => OVERRIDE_CELLS.filter((c) => c.group === g)),
  }))
  .filter((g) => g.cells.length);

/** 고르는 칸의 값(기본 따름 말고) */
const CHOICE_OPTIONS = {
  internal: [
    { value: false, label: '병원' },
    { value: true, label: '내부·테스트 — 청구 없음' },
  ],
  web_text: [
    { value: true, label: '원가 그대로 청구' },
    { value: false, label: '청구 안 함' },
  ],
};

/**
 * 묶음 안 칸 이름 — 요율 표·기본 요율 편집 모달과 같은 이름(RATE_CELLS 의 label). 상담사 번호 두 칸만 묶음 제목이 말하는
 * '상담사 번호'를 뺀다(검증·확인창은 RATE_CELLS 의 이름 그대로)
 */
const FIELD_LABELS = {
  'counselor_number.included': '기본 포함',
  'counselor_number.monthly': '추가 1개당',
};

/** 칸 아래 한 줄 설명 — 단위만으로 드러나지 않는 것만 */
const FIELD_HINTS = {
  'base.monthly': 'VAT 포함 금액 · 원 단위 정수',
  'base.minutes': '수신 통화와 웹 음성 · 분 단위 정수',
  'inbound.overage': '포함 통화를 넘은 10초 단위만 · 수신 · 웹 음성',
  'outbound.per_call': '무응답·음성사서함 포함 · 포함 통화와 따로',
  'outbound.unit': '환자가 받은 발신 통화만 · 포함 통화와 따로',
  'line.070': '포함 1회선 밖의 070 회선 1개',
  'counselor_number.included': '일반·착신전환·링그룹·내선 번호를 모두 셉니다',
  'counselor_number.monthly': 'VAT 별도 · 등록된 날만큼 일할',
};

const props = defineProps({
  open: { type: Boolean, required: true },
  companyId: { type: String, required: true },
  companyName: { type: String, default: '' },
  /** 상세의 달 'YYYY-MM' — 적용 시작 월 기본값 */
  month: { type: String, required: true },
  /** 이 회사 예외 버전들(GET .../plan-overrides `items`) */
  overrides: { type: Array, default: () => [] },
  /** 기본 요율 버전들(GET .../default-plans `items`) — "기본 따름" 값 */
  defaultPlans: { type: Array, default: () => [] },
  /** `cost_rates`(읽기 전용 원가) */
  costRates: { type: Object, default: null },
  /** settlementApi 또는 목(getSettlementApi()) */
  api: { type: Object, required: true },
});

const emit = defineEmits(['close', 'saved']);

const uid = `st-override-${getCurrentInstance()?.uid ?? 0}`;
const monthId = `${uid}-month`;
const memoId = `${uid}-memo`;

const form = reactive({ effectiveFrom: '', memo: '' });
/** 구분·웹 텍스트: FOLLOW | true | false */
const choices = reactive(Object.fromEntries(CHOICE_CELLS.map((c) => [c.key, FOLLOW])));
/** 판매가 칸: 값(원)과 "기본 따름" 여부 */
const values = reactive(Object.fromEntries(PRICE_CELLS.map((c) => [c.key, null])));
const follow = reactive(Object.fromEntries(PRICE_CELLS.map((c) => [c.key, true])));
const saving = ref(false);
// 연 직후 값 — 적용 시작 월을 바꿀 때 고친 것이 있으면 확인한다
let initialSignature = '';

// ---------------------------------------------------------------------------
// 고른 적용 시작 월의 버전들
// ---------------------------------------------------------------------------

const overrideItems = computed(() =>
  (Array.isArray(props.overrides) ? props.overrides : []).filter((o) => isValidMonth(o?.effective_from))
);
/** 그 달에 이미 있는 예외 버전(있으면 고친다) */
const existing = computed(() => overrideItems.value.find((o) => o.effective_from === form.effectiveFrom) ?? null);
/** 그 달 앞의 가장 최근 예외 버전(새 버전은 이 값을 복사해 연다) */
const previous = computed(() => {
  const before = addMonths(form.effectiveFrom, -1);
  return before ? effectiveOverride(overrideItems.value, before) : null;
});
/** 그 달 뒤의 첫 예외 버전 — 이 버전은 그 전 달까지만 쓴다 */
const nextVersion = computed(
  () =>
    overrideItems.value
      .filter((o) => o.effective_from > form.effectiveFrom)
      .sort((a, b) => a.effective_from.localeCompare(b.effective_from))[0] ?? null
);
const base = computed(() => existing.value ?? previous.value);
/** 적용 시작 월에 적용되는 기본 요율 버전 — "기본 따름" 값 */
const defaultPlan = computed(() => effectiveDefaultPlan(props.defaultPlans, form.effectiveFrom));

// ---------------------------------------------------------------------------
// 칸마다 보일 값(원가·단위·기본값·잠김)
// ---------------------------------------------------------------------------

const perMessage = computed(() =>
  isNumber(props.costRates?.web_text_per_message) ? props.costRates.web_text_per_message : 20
);

/** 입력 앞 단위 — 월 사용료·회선·상담사 번호 1개당은 '월', 발신 건당은 '건당', 10초 단가는 '10초당', 포함 통화·번호 수는 없음 */
function unitTextOf(cell, unitSec, locked) {
  if (cell.kind === 'monthly' || cell.kind === 'fee' || cell.kind === 'monthly_excl') return '월';
  if (cell.kind === 'per_call') return '건당';
  if (cell.kind === 'per_minute') return '1분당';
  if (cell.kind === 'minutes' || cell.kind === 'count' || locked) return '';
  return `${unitLabel(isNumber(unitSec) && unitSec > 0 ? unitSec : 10, cell.key)}당`;
}

/** 입력 뒤 단위 — 포함 통화는 '분', 상담사 번호 기본 포함 수는 '개', 나머지는 '원' */
function suffixOf(cell) {
  if (cell.kind === 'minutes') return '분';
  if (cell.kind === 'count') return '개';
  return '원';
}

/** 그 달 기본 버전이 v70 이전 모양 — "기본 따름" 값을 칸으로 읽을 수 없다 */
const defaultPlanLegacy = computed(() => isLegacyPlan(defaultPlan.value));

const info = computed(() => {
  const plan = defaultPlan.value;
  const fmt = { perMessage: perMessage.value };
  const out = {};
  for (const cell of OVERRIDE_CELLS) {
    // 원가는 오늘 cost_rates 먼저, 그 칸이 없으면 기본 요율 버전에 실린 원가 스냅샷(settlementRules.cellCostInfo)
    const costInfo = cellCostInfo(cell.key, { costRates: props.costRates, source: plan, prefer: 'live' });
    const d = readCell(plan, cell.key);
    // 예외 판매가는 그 달 기본 버전의 단위로 계산된다 — 단위는 기본 버전 것이 먼저(유효 요율 카드와 같다)
    const unitSec = d.unitSec ?? costInfo?.unitSec ?? null;
    // 원가·단위를 모르는 칸(cost_rates 에서 둘 다 null — PBX → 대표번호, vox 직접 통신료 대표번호)은 pending 이
    // 없어도 판매가를 넣을 수 없다(서버 400)
    const locked = ['price', 'per_call'].includes(cell.kind) && !!costInfo && isCostUnknown(cell.key, costInfo);
    const costLabel = costInfo && !locked ? formatCostValue(cell.key, costInfo) : '';
    // 원가가 기본 버전과 다른 단위면(버전 뒤에 공급사 단위가 바뀜) 원가 미만·마진 0 을 견주지 않는다(카드와 같다)
    // 1분당 칸은 원가를 1분당으로 바꿔 읽는다(cellCostInfo) — 과금 단위(10초)와 견주지 않는다
    const unitsDiffer =
      cell.kind !== 'per_minute' && isNumber(d.unitSec) && isNumber(costInfo?.unitSec) && d.unitSec !== costInfo.unitSec;
    let defaultText = '기본 요율 없음';
    if (defaultPlanLegacy.value) {
      defaultText = '기본 v70 이전 모양';
    } else if (plan) {
      defaultText =
        cell.kind === 'internal'
          ? `기본 ${categoryLabel(d.value === true)}`
          : `기본 ${formatRateValue(cell.key, d.value, unitSec, fmt)}`;
    }
    out[cell.key] = {
      locked,
      unitSec,
      unitText: unitTextOf(cell, unitSec, locked),
      cost: unitsDiffer ? null : costInfo?.cost ?? null,
      // 원가 열 머리가 '원가 (참고)'라 '원가' 를 붙이지 않는다
      costText: costLabel && costLabel !== EMPTY ? costLabel : '',
      defaultText,
    };
  }
  return out;
});

const isChoiceCell = (cell) => CHOICE_KINDS.has(cell.kind);

function fieldLabel(cell) {
  return FIELD_LABELS[cell.key] ?? cell.label;
}

function choiceHint(key) {
  if (key === 'internal' && choices.internal === true) {
    return '청구 0원으로 확정되고 마진을 계산하지 않습니다. 경고는 모두 비차단으로 기록만 합니다.';
  }
  if (key === 'web_text' && choices.web_text === false) {
    return '웹 텍스트(웹 테스트 포함)를 청구하지 않습니다. 웹 음성은 그대로 120분 사용량에 듭니다.';
  }
  return '';
}

/**
 * 직전 예외 버전에서 복사돼 온 상담사 번호 값 — 새 버전은 직전 버전을 복사해 열려, 한 달 면제(0) 뒤의 버전에서 그 0 을
 * '기본 따름'으로 되돌리는 것을 잊지 않게 표시한다(번호 요청 A2). 고치거나 기본 따름으로 바꾸면 사라진다.
 */
function copiedFromText(cell) {
  if (cell.group !== 'counselor_number' || existing.value || !previous.value) return '';
  const copied = getPath(previous.value, cell.pricePath);
  if (!isNumber(copied) || follow[cell.key] || values[cell.key] !== copied) return '';
  return `직전 예외 버전(${previous.value.effective_from})에서 복사한 값`;
}

/** 칸 아래 회색 설명 — 칸 설명과 복사돼 온 값 표시 */
function fieldHint(cell) {
  return [FIELD_HINTS[cell.key], copiedFromText(cell)].filter(Boolean).join(' · ');
}

/**
 * 그 적용 시작 월의 기본 요율에 상담사 번호 블록이 없을 때(번호 요청 A2·요청 계약 2) — "기본 따름" 값은 '요금 없음'이고, call-api 는
 * 기본 요율에 블록이 없는 달에 예외만으로 요금을 켜지 않는다(판정은 달마다, 예외 버전은 다음 예외 버전 전까지 이어진다).
 * 기본 버전이 없거나 v70 이전 모양이면 묶음 위 안내(defaultPlanNote)가 대신 말한다.
 */
const counselorNoBlockNote = computed(() => {
  const plan = defaultPlan.value;
  if (!plan || defaultPlanLegacy.value || counselorNumberRates(plan) !== null) return '';
  return '이 달 기본 요율에는 상담사 번호 요금이 없어 이 달에는 예외 값을 쓰지 않습니다.';
});

// ---------------------------------------------------------------------------
// 안내 문구
// ---------------------------------------------------------------------------

const versionNote = computed(() => {
  const ef = form.effectiveFrom;
  let head = '새 버전 — 이전 예외 버전이 없어 모든 칸이 기본 따름으로 열립니다.';
  if (existing.value) head = `${ef} 예외 버전을 고칩니다.`;
  else if (previous.value) head = `새 버전 — 직전 예외 버전(${previous.value.effective_from}) 값을 복사해 엽니다.`;
  const next = nextVersion.value;
  if (!next) return `${head} ${ef}부터 계속 씁니다.`;
  const until = addMonths(next.effective_from, -1);
  const range = until === ef ? `${ef} 한 달만 씁니다` : `${ef} ~ ${until}에 씁니다`;
  return `${head} ${range}(${next.effective_from}부터는 그 버전).`;
});

const defaultPlanNote = computed(() => {
  const plan = defaultPlan.value;
  if (!plan) {
    return `${form.effectiveFrom}에 적용되는 기본 요율 버전이 없습니다. 기본 요율이 없는 달은 예외와 상관없이 금액을 계산하지 않습니다.`;
  }
  if (defaultPlanLegacy.value) {
    return `${form.effectiveFrom}에 적용되는 기본 요율(${plan.effective_from} 버전)이 요금표 v70 이전 모양이라 그 달은 예외와 상관없이 금액을 계산하지 않습니다. 기본 요율 화면에서 그 버전을 새 칸으로 다시 저장하세요.`;
  }
  return `"기본 따름" 옆 회색 값은 ${form.effectiveFrom}에 적용되는 기본 요율(${plan.effective_from} 버전)입니다.`;
});

// 확정 정산이 이미 쓴 버전을 고치면 — 확정된 달은 스냅샷이라 그대로다(트레이드오프 "이미 확정된 달은…")
const usedByConfirmedText = computed(() => {
  const n = existing.value?.confirmed_statements;
  if (!isNumber(n) || n <= 0) return '';
  return `이 버전을 쓴 확정 정산 ${formatNumber(n)}건은 바뀌지 않습니다. 이미 쓰인 단가를 바꾸려면 다음 달 버전을 만드세요.`;
});

/** 고치거나 복사할 예외 버전에 남은 v70 이전 칸 — 계산에 쓰지 않고, 저장하면 빠진다(개정 2) */
const legacyCellsText = computed(() => {
  const cells = legacyOverrideCells(base.value);
  if (!cells.length) return '';
  const names = cells.map((c) => c.label).join(', ');
  const from = base.value.effective_from;
  return `${from} 예외 버전에 요금표 v70 이전 칸 ${formatNumber(cells.length)}개(${names})가 남아 있습니다. 계산에 쓰지 않으며, 이 창에서 저장하면 빠집니다.`;
});

const memoHint = computed(() => {
  if (existing.value || !previous.value) return '';
  const memo = typeof previous.value.memo === 'string' ? previous.value.memo.trim() : '';
  return memo ? `직전 버전(${previous.value.effective_from}) 메모 · ${memo}` : '';
});

const extrasText = computed(() => {
  const rows = extraItemRows(defaultPlan.value?.extras, props.costRates?.extras);
  const unset = rows.filter((r) => r.price === '미정').length;
  const state = unset === rows.length ? '판매가 미정' : `판매가 미정 ${unset}개`;
  return `레터링·문자·개인정보 보호 ${rows.length}개 · ${state}`;
});

const clearBlockedReason = computed(() =>
  overrideBodyCellKeys(base.value).length ? '' : '이 적용 시작 월에 쓰는 예외 칸이 없어 해제할 것이 없습니다.'
);

// ---------------------------------------------------------------------------
// 폼 열기·적용 시작 월 바꾸기
// ---------------------------------------------------------------------------

/** 지금 폼 → 예외 칸 값(덮는 칸만). 원가를 모르는 칸은 빼고, 비운 칸은 기본 따름이다 */
function buildValues() {
  const out = {};
  for (const cell of CHOICE_CELLS) {
    if (choices[cell.key] !== FOLLOW) out[cell.key] = choices[cell.key];
  }
  for (const cell of PRICE_CELLS) {
    if (follow[cell.key] || info.value[cell.key].locked) continue;
    if (isNumber(values[cell.key])) out[cell.key] = values[cell.key];
  }
  return out;
}

const signature = () => JSON.stringify({ values: buildValues(), memo: form.memo.trim() });

/** 적용 시작 월의 버전(없으면 직전 버전 복사, 그것도 없으면 전부 기본 따름)으로 폼을 채운다 */
function resetForm(effectiveFrom) {
  form.effectiveFrom = effectiveFrom;
  const source = overrideToFormValues(base.value);
  for (const cell of CHOICE_CELLS) {
    choices[cell.key] = typeof source[cell.key] === 'boolean' ? source[cell.key] : FOLLOW;
  }
  for (const cell of PRICE_CELLS) {
    const has = isNumber(source[cell.key]) && !info.value[cell.key].locked;
    values[cell.key] = has ? source[cell.key] : null;
    follow[cell.key] = !has;
  }
  // 메모는 그 버전을 고칠 때만 잇는다 — 새 버전은 사유를 새로 적는다(직전 메모는 아래에 참고로 보인다)
  form.memo = existing.value && typeof existing.value.memo === 'string' ? existing.value.memo : '';
  initialSignature = signature();
}

// 열 때마다 상세의 달로 다시 채운다 — 닫았다 다시 열면 이전 입력이 남지 않게
watch(
  () => props.open,
  (open) => {
    if (open) resetForm(isValidMonth(props.month) ? props.month : currentMonthKst());
  },
  { immediate: true }
);

function onMonthChange(next) {
  if (!isValidMonth(next) || next === form.effectiveFrom) return;
  if (signature() === initialSignature) {
    resetForm(next);
    return;
  }
  // 피커는 form.effectiveFrom 에 묶여 있어 취소하면 원래 달이 그대로 보인다
  Modal.confirm({
    title: '적용 시작 월 바꾸기',
    content: `${next} 버전 값으로 다시 엽니다. 지금 고친 값과 메모는 사라집니다.`,
    okText: '바꾸기',
    cancelText: '그대로 두기',
    onOk: () => resetForm(next),
  });
}

function handleCancel() {
  if (saving.value) return;
  emit('close');
}

// ---------------------------------------------------------------------------
// 저장·전부 해제
// ---------------------------------------------------------------------------

/** 확인창 본문 — 앞 문장 + 목록 */
function confirmContent(lead, lines) {
  return h('div', null, [
    h('p', { style: 'margin: 0 0 8px; word-break: keep-all;' }, lead),
    h(
      'ul',
      { style: 'margin: 0; padding-left: 18px;' },
      lines.map((line) => h('li', line))
    ),
  ]);
}

function validationError() {
  for (const cell of PRICE_CELLS) {
    if (follow[cell.key] || info.value[cell.key].locked) continue;
    const error = validateRateCell(cell.key, values[cell.key]);
    if (error) return error;
  }
  return form.memo.trim() ? null : MEMO_REQUIRED_TEXT;
}

function confirmSave() {
  if (saving.value) return;
  const error = validationError();
  if (error) {
    message.warning(error);
    return;
  }
  const cellValues = buildValues();
  if (!Object.keys(cellValues).length) {
    // [예외 전부 해제]가 꺼졌으면(해제할 예외 칸이 없다) 그 버튼으로 보내지 않는다
    message.warning(clearBlockedReason.value ? NO_CELLS_NOTHING_TO_CLEAR_TEXT : NO_CELLS_TEXT);
    return;
  }
  const effectiveFrom = form.effectiveFrom;
  const body = formValuesToOverrideBody(cellValues, form.memo);
  // 덮는 칸과 값 — 단위는 입력 칸과 같은 것(기본 버전 단위 먼저)
  const fmt = { perMessage: perMessage.value };
  const cells = overrideBodyCellKeys(body).map((key) => {
    const cell = RATE_CELL_MAP[key];
    return `${cell.label} ${formatRateValue(key, getPath(body, cell.pricePath), info.value[key]?.unitSec ?? null, fmt)}`;
  });
  const lines = usedByConfirmedText.value
    ? [...OVERRIDE_SAVE_EFFECT_LINES, usedByConfirmedText.value]
    : [...OVERRIDE_SAVE_EFFECT_LINES];
  Modal.confirm({
    title: '예외 저장',
    content: () => confirmContent(`적용 시작 ${effectiveFrom} · 덮는 칸 ${cells.length}개: ${cells.join(', ')}`, lines),
    okText: '저장',
    cancelText: '취소',
    // 실패해도 resolve 한다 — 확인창은 닫고 이 창은 연 채 알린다(고친 값을 잃지 않게)
    onOk: () => submit(effectiveFrom, body, 'saved'),
  });
}

function confirmClear() {
  if (saving.value || clearBlockedReason.value) return;
  const memo = form.memo.trim();
  if (!memo) {
    message.warning(MEMO_REQUIRED_TEXT);
    return;
  }
  const effectiveFrom = form.effectiveFrom;
  Modal.confirm({
    title: '예외 전부 해제',
    content: () =>
      confirmContent(CLEAR_LEAD, [`적용 시작 ${effectiveFrom} · 메모: ${memo}`, ...OVERRIDE_SAVE_EFFECT_LINES]),
    okText: '전부 해제',
    okType: 'danger',
    cancelText: '취소',
    onOk: () => submit(effectiveFrom, formValuesToOverrideBody({}, memo), 'cleared'),
  });
}

async function submit(effectiveFrom, body, kind) {
  saving.value = true;
  try {
    await props.api.putPlanOverride(props.companyId, effectiveFrom, body);
    emit('saved', { kind, effectiveFrom });
  } catch (err) {
    const fallback = kind === 'cleared' ? '예외를 해제하지 못했습니다.' : '예외를 저장하지 못했습니다.';
    const text = parseCallApiError(err, fallback, { unavailableMessage: UNAVAILABLE_TEXT });
    // 400 VALIDATION_ERROR 는 고칠 수 있는 입력 문제다(서버 문구가 칸을 말한다)
    if (getCallApiErrorStatus(err) === 400) message.warning(text);
    else message.error(text);
  } finally {
    saving.value = false;
  }
}
</script>

<style scoped lang="scss">
@use '../../styles/settlement' as *;

@include st-modal;
@include yellow-button;

.modal-title__sub {
  margin-left: 8px;
  color: $st-muted;
  font-size: 13px;
  font-weight: 500;
}

.modal-footer__start {
  margin-right: auto;
}

.override-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 4px;
  font-size: 13px;
  color: $st-text;

  &__intro {
    margin: 0;
    color: $st-text-secondary;
    line-height: 1.6;
  }

  &__help {
    margin-left: 4px;
    color: $st-muted;
    cursor: help;
  }

  // '원가 (참고)' 열 머리 — 칸의 오른쪽 열(110px) 위
  &__colhead {
    display: flex;
    justify-content: flex-end;
    padding: 0 14px 2px;
    font-size: 12px;
    color: $st-muted;

    span {
      width: 110px;
      text-align: right;
    }
  }

  &__label {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: $st-text;

    em {
      font-style: normal;
      color: $st-danger;
    }
  }

  // RatePriceField 와 같은 두 칸 배치(이름 | 입력)
  &__month {
    display: grid;
    grid-template-columns: minmax(110px, 150px) minmax(0, 1fr);
    gap: 6px 16px;
    align-items: start;

    .override-form__label {
      padding-top: 5px;
    }
  }

  &__month-body {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 12px;
    min-width: 0;
  }

  &__picker {
    width: 140px;
  }

  &__version {
    color: $st-text-secondary;
    font-size: 12.5px;
    line-height: 1.5;
  }

  &__hint {
    margin: 0;
    color: $st-muted;
    font-size: 12px;
    line-height: 1.5;
  }

  &__group {
    padding: 2px 14px 4px;
    border: 1px solid $st-border;
    border-radius: 10px;

    &.is-readonly {
      background: $st-bg;
    }

    // 행 사이 구분선 — 고르는 칸·판매가 칸 모두 여기서 긋는다
    > .choice-field + .choice-field,
    > .choice-field + .price-field,
    > .price-field + .choice-field,
    > .price-field + .price-field {
      border-top: 1px solid $st-border;
    }
  }

  &__group-title {
    margin: 10px 0 2px;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.4;
    color: $st-text;

    small {
      font-size: 13px;
      font-weight: 400;
      color: $st-muted;
    }
  }

  // 묶음 제목 아래 안내(상담사 번호 — 예외가 이어지는 범위, 그 달 기본 요율에 요금이 없을 때)
  &__group-hint {
    margin: 0 0 4px;
    color: $st-muted;
    font-size: 12px;
    line-height: 1.5;

    &.is-warn {
      color: $st-warning;
    }
  }

  &__memo {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
}

// 구분·웹 텍스트 — RatePriceField 와 같은 세 칸 배치(이름 | 고르기 | 원가)
.choice-field {
  display: grid;
  grid-template-columns: minmax(110px, 150px) minmax(0, 1fr) 110px;
  gap: 4px 16px;
  align-items: start;
  padding: 10px 0;
  font-size: 13px;

  &__label {
    padding-top: 5px;
    font-size: 13.5px;
    font-weight: 600;
    color: $st-text;
    word-break: keep-all;
  }

  &__cost {
    padding-top: 5px;
    color: $st-muted;
    font-size: 13px;
    text-align: right;
    @include st-num;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
    padding-top: 5px;
  }

  &__options {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 16px;
  }

  &__default {
    margin-left: 6px;
    color: $st-muted;
    font-size: 12px;
  }

  &__hint {
    grid-column: 2 / 4;
    margin: 0;
    color: $st-muted;
    font-size: 12.5px;
    line-height: 1.5;
  }

  @media (max-width: 560px) {
    grid-template-columns: minmax(0, 1fr);

    &__cost {
      padding-top: 0;
      text-align: left;
    }

    &__hint {
      grid-column: auto;
    }
  }
}

.readonly-list {
  margin: 0 0 6px;

  &__row {
    display: grid;
    grid-template-columns: minmax(110px, 150px) minmax(0, 1fr);
    gap: 6px 16px;
    padding: 6px 0;

    & + & {
      border-top: 1px solid $st-border;
    }
  }

  dt {
    font-weight: 600;
    color: $st-text-secondary;
  }

  dd {
    margin: 0;
    color: $st-text-secondary;
    line-height: 1.5;
  }
}
</style>
